import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

interface SessionTimerProps {
    startTime: string | Date;
}

export const SessionTimer: React.FC<SessionTimerProps> = ({ startTime }) => {
    const [elapsed, setElapsed] = useState<number>(0);

    useEffect(() => {
        const start = new Date(startTime).getTime();

        const updateTimer = () => {
            const now = Date.now();
            setElapsed(Math.max(0, Math.floor((now - start) / 1000)));
        };

        updateTimer();
        const interval = setInterval(updateTimer, 1000);

        return () => clearInterval(interval);
    }, [startTime]);

    const formatTime = (totalSeconds: number): string => {
        const hrs = Math.floor(totalSeconds / 3600);
        const mins = Math.floor((totalSeconds % 3600) / 60);
        const secs = totalSeconds % 60;

        const pad = (num: number) => String(num).padStart(2, "0");

        if (hrs > 0) {
            return `${pad(hrs)}:${pad(mins)}:${pad(secs)}`;
        }
        return `${pad(mins)}:${pad(secs)}`;
    };

    return (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <AccessTimeIcon fontSize="small" />
            <Typography variant="body2" color="inherit" style={{ fontWeight: "bold", fontFamily: "monospace" }}>
                {formatTime(elapsed)}
            </Typography>
        </div>
    );
};
